import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { ArrowDownIcon } from '../../components/icons';
import styles from './select-mobile.scss';

class SelectMobile extends Component {
  handleChange = event => {
    _.invoke(this, 'props.onChange', event.target.value);
  };

  renderOptions() {
    return _.map(this.props.options, ({ value, label }) =>
      <option key={value} value={value} name={label}>
        {label}
      </option>
    );
  }

  render() {
    const { defaultValue } = this.props;
    return (
      <div className={styles.container}>
        <select
          className={classNames(styles.select, 'forum-text-color', 'select-mobile__select')}
          onChange={this.handleChange}
          defaultValue={defaultValue}
        >
          {this.renderOptions()}
        </select>
        <ArrowDownIcon className={classNames(styles.selectIcon, 'forum-icon-fill')}/>
        <div className={classNames(styles.borders, 'forum-text-border-color')}/>
      </div>
    );
  }
}

SelectMobile.propTypes = {
  cardBackgroundColor: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ),
};

export default SelectMobile;



// WEBPACK FOOTER //
// ./app/components/select/select-mobile.js